export interface GetWalletSaleHistoryTransactionData {
  username: string;
  userPhoto: string;
  transactionType: string;
  eventName: string;
  transactionDate: string;
  quantity: number;
  grossValue: number;
  netValue: number;
  currencyType: string;
  transactionHash: string;
}

export interface GetWalletSaleHistoryTransactions {
  content: GetWalletSaleHistoryTransactionData[];
  totalElements: number;
  totalPages: number;
  pageNumber: number;
  pageSize: number;
}

export interface GetWalletSaleHistoryData {
  saleId: string;
  saleName: string;
  transactions: GetWalletSaleHistoryTransactions;
}

export interface GetWalletSaleHistory {
  timestamp: string;
  status: string;
  data: GetWalletSaleHistoryData;
  error?: any;
  errors?: any[];
  page?: number;
  metadata?: Record<string, any>;
  translations?: Record<string, string>;
  total_pages?: number;
  per_page?: number;
  total_items?: number;
}

export function createEmptyWalletSaleHistoryData(): GetWalletSaleHistoryData {
  return {
    saleId: '',
    saleName: '',
    transactions: {
      content: [],
      totalElements: 0,
      totalPages: 0,
      pageNumber: 0,
      pageSize: 20,
    },
  };
}